import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CSS_CLASS_PREFIX } from "../../constants/css";
import { cssMainSelector } from "../../lib/cssSelectors";
import { withTranslation } from "react-i18next";
import MaterialIcon from "../MaterialIcon";
import Image from "../Image";

const Container = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${(p) => p.theme.spacing.md};
  }
`;

const Legenda = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: ${(p) => p.theme.spacing.md};
    width: 100%;
  }
`;

const Title = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    font-weight: ${(p) => p.theme.font.weightBold};
    order: 0;
  }
`;

const LogoContainer = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    order: 1;
  }
`;

const LogoWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    padding: ${(p) => p.theme.spacing.sm};

    &.${CSS_CLASS_PREFIX}-hidden {
      display: none;
    }
  }
`;

const Logo = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    align-items: center;
    background-color: ${(p) => p.theme.filter.logoListFilter.backgroundColor};
    border: 1px solid ${(p) => p.theme.filter.logoListFilter.borderColor};
    border-radius: ${(p) => p.theme.generic.borderRadius};
    cursor: pointer;
    display: flex;
    height: 55px;
    justify-content: center;
    width: 55px;

    img {
      display: block;
      flex: 0 0 auto;
      width: 45px;
    }

    &:hover {
      background-color: ${(p) =>
        p.theme.filter.logoListFilter.hoverBackgroundColor};
    }

    &.${CSS_CLASS_PREFIX}-selected {
      border-width: 3px;
    }
  }
`;

const CollapseLink = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    * {
      color: ${(p) => p.theme.filter.collapseLinkColor};
      cursor: pointer;
      padding-top: ${(p) => p.theme.spacing.sm};
      user-select: none;
    }
  }
`;

class LogoListFilter extends PureComponent {
  render() {
    const { onCollapseClick, title } = this.props;
    let logos = this.logos();

    return (
      <Container>
        <Legenda>
          <Title>{title}</Title>
        </Legenda>
        <LogoContainer>{logos}</LogoContainer>
        <CollapseLink onClick={onCollapseClick}>
          {this.collapseText()}
        </CollapseLink>
      </Container>
    );
  }

  logos() {
    const { collapsed, maxShow, onClick, value, values } = this.props;
    const logos = [];
    let i = 0;

    for (const [logoValue, logoAlt, logoImage] of values) {
      i += 1;
      let logoWrapperClass = `${CSS_CLASS_PREFIX}-show`;
      let logoClass;

      if (collapsed && maxShow && i > maxShow) {
        logoWrapperClass = `${CSS_CLASS_PREFIX}-hidden`;
      }

      if (value.indexOf(logoValue.toString()) >= 0) {
        logoClass = `${CSS_CLASS_PREFIX}-selected`;
      }

      logos.push(
        <LogoWrapper className={logoWrapperClass} key={logoValue}>
          <Logo className={logoClass} onClick={onClick.bind(this, logoValue)}>
            <Image src={logoImage} alt={logoAlt} isResponsive={false} />
          </Logo>
        </LogoWrapper>
      );
    }

    return logos;
  }

  collapseText() {
    const { collapsed, maxShow, t, values } = this.props;

    if (maxShow && values.length > maxShow) {
      if (collapsed) {
        const count = values.length - maxShow;

        return (
          <span>
            <span>{t("unCollapseText", { count: count })}</span>{" "}
            <MaterialIcon>arrow_drop_down</MaterialIcon>
          </span>
        );
      } else {
        return (
          <span>
            {t("collapseText")} <MaterialIcon>arrow_drop_up</MaterialIcon>
          </span>
        );
      }
    } else {
      return "";
    }
  }
}

LogoListFilter.propTypes = {
  collapsed: PropTypes.bool,
  maxShow: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  onCollapseClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.array.isRequired
};

export default withTranslation(["filters"])(LogoListFilter);
